import React, { Component } from 'react';
import { connect } from 'react-redux';
import { push, replace } from 'react-router-redux';
import {
  Container, Image, Label,
  Loader, Segment
} from 'semantic-ui-react';
import { Link } from 'react-router-dom';
import feathersConnect from './../../providers/feathersConnect';

class HomeView extends Component {

  constructor (props) {
    super(props);

    this.state = {
      loading: false,
      portada: null
    };

    this.PublicPagesSservice = this.props.feathers.service('/api/public-pages');
  }

  findPortadaValue () {
    this.setState({
      loading: true
    });

    this.PublicPagesSservice.find({
      query: {
        name: 'portada'
      }
    })
      .then(response => {
        console.log(response);
        let formattedResponse = {
          ...response,
          htmlValue: response.htmlValue.replace(/<img/g, '<img class="ui image centered"')
        };

        this.setState({
          portada: formattedResponse,
          loading: false
        });
      })
      .catch(error => {
        console.log(error);
        this.setState({
          loading: false
        });
      });
  }

  componentDidMount () {
    this.findPortadaValue();
  }

  static mapStateToProps (state) {
    return {
      routing: state.routing,
      authentication: state.authentication.toJS({ deep: true })
    };
  }

  static mapDispatchToProps (dispatch) {
    return {
      navigate: (path) => {
        dispatch(push(path));
      }
    };
  }

  render () {
    let {
      loading,
      portada
    } = this.state;

    if (loading) {
      return <Loader active inline="centered" content="Cargando Contenido"/>;
    }

    if (!portada) {
      return (
        <Container style={{ padding: 16 }}>
          <Segment vertical textAlign="center">
            <Image centered style={{ maxHeight: 400 }} src={require('../../assets/img/logo_dgc.jpg')} />
          </Segment>
        </Container>
      );
    } else {
      function createMarkup () {
        return {
          __html: portada.htmlValue
        };
      };

      return (
        <Container fluid>
          <Container style={{ padding: 16 }}>
            <div className="quill">
              <div className="ql-editor" dangerouslySetInnerHTML={createMarkup()}>

              </div>
            </div>
          </Container>
          <Container className="bg-green-dust" fluid style={{ backgroundColor: '#72bd4b', padding: 16, height: 200 }}>

          </Container>
        </Container>
      );
    }
  }
}

export default feathersConnect(
  connect(
    HomeView.mapStateToProps,
    HomeView.mapDispatchToProps
  )(HomeView)
);



// WEBPACK FOOTER //
// ./client/components/pages/HomeView.js